import type { ReactNode } from "react";

import SummarySection from "./sections/SummarySection";
import TeamMembersSection from "./sections/TeamMembersSection";
import SquadsSection from "./sections/SquadsSection";
import RatesSection from "./sections/RatesSection";
import SettlementsSection from "./sections/SettlementsSection";
import ContractorsSection from "./sections/ContractorsSection";
import EngagementsSection from "./sections/EngagementsSection";
import BonusesSection from "./sections/BonusesSection";

// ---------------------------------------------------------------------------
// Fuente única de navegación de la mini-app "Equipo"
// (issues AgroCloud#11/#12/#13/#60). Alimenta:
//   - el sub-menú por sección (TeamLayout)
//   - las rutas anidadas (router/config.tsx vía routes.tsx)
//   - el tile del apps-sidebar (AppsSidebar/appsConfig.tsx)
// Las etiquetas son claves i18n resueltas al render en el layout.
// ---------------------------------------------------------------------------

export interface TeamNavItem {
  id: string; // segmento de ruta bajo /team
  labelKey: string; // clave i18n del namespace common
  icon: string; // clase remixicon del sub-menú
  element: ReactNode;
  /** Secciones con dinero (#742): ver la nota en `payroll/config.tsx`. */
  adminOnly?: boolean;
}

export const MENU: TeamNavItem[] = [
  {
    id: "summary",
    labelKey: "team.menu.summary",
    icon: "ri-dashboard-line",
    element: <SummarySection />,
  },
  {
    id: "members",
    labelKey: "team.menu.teamMembers",
    icon: "ri-team-line",
    element: <TeamMembersSection />,
  },
  {
    id: "squads",
    labelKey: "team.menu.squads",
    icon: "ri-group-2-line",
    element: <SquadsSection />,
  },
  {
    id: "rates",
    labelKey: "team.menu.rates",
    icon: "ri-price-tag-3-line",
    element: <RatesSection />,
  },
  {
    // #1365: bonos individuales con vigencia (por periodo o por rango).
    id: "bonuses",
    labelKey: "team.menu.bonuses",
    icon: "ri-gift-line",
    element: <BonusesSection />,
  },
  {
    id: "settlements",
    labelKey: "team.menu.settlements",
    icon: "ri-money-dollar-circle-line",
    element: <SettlementsSection />,
  },
  {
    id: "contractors",
    labelKey: "team.menu.contractors",
    icon: "ri-briefcase-line",
    element: <ContractorsSection />,
  },
  {
    id: "engagements",
    labelKey: "team.menu.engagements",
    icon: "ri-hammer-line",
    element: <EngagementsSection />,
  },
];

export const TEAM_BASE = "/team";

/** Ruta de aterrizaje por defecto (resumen). */
export const teamDefaultRoute = `${TEAM_BASE}/${MENU[0].id}`;

/** Metadatos del tile del apps-sidebar. */
export const teamApp = {
  id: "team",
  iconClass: "ri-group-line",
  color: "bg-lime-600",
  route: teamDefaultRoute,
};
